// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1rAdgZOmMv1mKVCW-vBnLz","primary":"primary-2_lUT8HRsrRLOC5WE-8Hik","plain-text":"plain-text-U1d1-lerei0D_JdayQ0Zl","plainText":"plain-text-U1d1-lerei0D_JdayQ0Zl"};